import LayoutActividad from "../../../components/LayoutActividad";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import { modulo13 } from "../../../routes/Module13";
import Sidebar from "../Sidebar";
import GuiaDocente from "../../../components/GuiaDocente";
import Mapa from "../../../svg/mapas";
import AudioPlayer from "../../../audioPlayer/AudioPlayer";
import Audio from "../../../audios/modulo13/Unidad1Actividad2.mp3";

const Actividad3 = () => {
  const infoUnidad = modulo13.content[0];
  const infoAct = modulo13.content[0].activities[1];
  const crumbs = [
    {
      title: modulo13.title,
      url: "/" + modulo13.url,
    },
    {
      title:
        modulo13.content.length === 1
          ? `${infoAct.name}`
          : `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];

  const pages = {
    titleNext: `${modulo13.content[0].name}: ${modulo13.content[0].activities[2].name}`,
    linkNext: `${modulo13.url}/${modulo13.content[0].path}/${modulo13.content[0].activities[2].path}`,
    titlePrev: `${modulo13.content[0].name}: ${modulo13.content[0].activities[0].name}`,
    linkPrev: `${modulo13.url}/${modulo13.content[0].path}/${modulo13.content[0].activities[0].path}`,
  };
  const metadata = {
    color: modulo13.color,
    title: `${modulo13.title} - ${infoAct.name}`,
    name: modulo13.title,
  };

  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <p>
        <small className={`c-${modulo13.color} hat-text`}>
          <FontAwesomeIcon icon={faEye} /> Observamos
        </small>
      </p>

      <h2 className="mb-5">{infoAct.name}</h2>
          <AudioPlayer track={Audio} />

      <ul>
        <li>Observa la imagen.</li>
        <li>
          El territorio del Perú está dividido en departamentos. Marca con un
          clic el departamento en el que vives.
        </li>
        <li>
          Luego, en una hoja, dibuja algo característico del territorio de tu
          departamento.
        </li>
      </ul>

      <div className="row">
        <div className="col-lg-8 col-12 text-center">
          <Mapa />
        </div>
      </div>

      <GuiaDocente>
        <ul>
          <li>
            Lea la primera indicación: Observa la imagen. Pida que observen la imagen en silencio y, luego, pregunte:
            <ul>
              <li>
                <i>
                  “¿Qué observamos en la imagen? (Posible respuesta: Un mapa del
                  Perú)”.
                </i>
              </li>
              <li>
                <i>
                  “¿Cómo está dividido? (Posible respuesta: En departamentos)”.
                </i>
              </li>
            </ul>
          </li>

          <li>
            Lea la segunda indicación: El territorio del Perú está dividido en
            departamentos. Marca con un clic el departamento en el que vives. Dé
            un tiempo para que trabajen y, luego, revise que
            hayan marcado el departamento correcto. Acerca de la división en
            departamentos, comente los siguientes puntos:
            <ul>
              <li>
                <i>
                  “¿Por qué el Perú se divide en departamentos? Es una forma de
                  organizar el territorio que busca que cada departamento tenga
                  autonomía política y económica. Así, cada departamento tiene
                  su Gobierno Regional, lo que permite que las acciones del
                  Estado no estén concentradas en un solo lugar, sino más bien
                  que lleguen a distintas partes del territorio”.
                </i>
              </li>
              <li>
                <i>
                  “¿Siempre se dividió en departamentos? No. A lo largo de los
                  diferentes gobiernos republicanos se ha tratado de reorganizar
                  el territorio. Eso ha hecho que algunas veces se les llame
                  “departamentos” y otras veces “regiones”. Con el proceso de
                  regionalización se trató de que algunos departamentos se
                  juntaran y formaran una “macrorregión” pero esto no ha
                  funcionado. Si bien actualmente se les llama indistintamente
                  “departamentos” o “regiones”, lo correcto es decir que tenemos
                  departamentos dirigidos por sus Gobiernos Regionales. Desde el
                  año 2002, tenemos 24 departamentos, una Provincia
                  Constitucional del Callo y el rango especial que recibe Lima
                  Metropolitana para que tenga autonomía del Departamento de
                  Lima”.
                </i>
              </li>
            </ul>
          </li>

          <li>
            Lea la última indicación: Luego, en una hoja, dibuja algo
            característico del territorio de tu departamento. Pida que describan el dibujo que han hecho.
          </li>
        </ul>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad3;
